<app-breadcrumb></app-breadcrumb>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
    <div class="col-6"></div>
    <div class="col-1" *ngIf="listOfUsersData && listOfUsersData.reviewStatus!=undefined && listOfUsersData.reviewStatus=='Reviewed'"></div>
    <div class="col-1 addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="updateFunction()" (keydown.enter)="updateFunction()"
        *ngIf="listOfUsersData && listOfUsersData.reviewStatus!='Reviewed'">
        <span class="reload_text text-white">Update</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
    </div>
    <div class=" col-1 button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="CancelFunction()">
            Cancel
        </button>
    </div>
</div> &nbsp;&nbsp;
<div class="row">
    <div class="row">
        <div class="col-md-3">
            <label for="email" id="reviewperiod"><b>Review period </b>:</label>
            <input type="text" style="width: 98%;" [(ngModel)]="this.message.reviewPeriodName"
                class="search-filed-continers" type="text" disabled>
        </div>
        <div class="col-md-9">
            <div><label for="email" id="reviewdescription"><b>Periodic Review Description</b></label> :</div>
            <textarea class="input-filed-textarea" rows="2" cols="50" style="min-height: 50px;"
                [(ngModel)]="this.message.reviewPeriodDescription" disabled></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <label for="email"><b>User Name</b> : </label>
            <input type="text" style="width: 98%;" [(ngModel)]="listOfUsersData.userFullname"
                class="search-filed-continers" type="text" disabled>
        </div>
        <div class="col-md-3">
            <label for="email"><b>From Date</b> : </label>
            <input type="text" style="width: 98%;" class="form-control data-picker-continer" bsDatepicker
                [disabled]="isFixedPeriod" [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="fromDate">
        </div>
        <div class="col-md-3">
            <label for="email"><b>To Date</b> : </label>
            <input type="text" style="width: 98%;" class="form-control data-picker-continer" bsDatepicker
                [disabled]="isFixedPeriod" [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="toDate">
        </div>
        <div class="col-md-3">
            <label for="email"><b>Reviewer</b>:</label>
            <input type="text" style="width: 98%;" [(ngModel)]="listOfUsersData.reviewUser"
                class="search-filed-continers" type="text" disabled>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div><label for="email" ><b>Comments</b></label><span
                    class="mandatory-symbol">*</span> :</div>
            <textarea class="input-filed-textarea" rows="2" cols="50" style="min-height: 50px;"
                [(ngModel)]="listOfUsersData.comments"></textarea>
        </div>
        <div class="col-md-3">
            <div><label for="email" ><b>Review Status</b></label><span
                    class="mandatory-symbol">*</span> :</div>
            <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedReviewStatus"
                [settings]="singleSelectDropdownSetting" [data]="reviewStatusDropDown">
            </ng-multiselect-dropdown>
        </div>
        <div class="col-md-3" *ngIf="listOfUsersData.reviewedOn!=null">
            <label for="email" ><b>Reviewed On </b>:</label>
            <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
                [disabled]="isFixedPeriod" [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="listOfUsersData.reviewedOn">
        </div>
    </div>
    <br>
</div>
<br>
<!--Details grid -->
<div class="row">
    <div class="menu-container">
        <div class="row menu-row-container">
            <div class="col-sm-6 ">
                <span class="report_title">Training Review</span>
            </div>
            <div class="col-sm-5 "></div>
        </div>
    </div>
    <div class="table-container">
        <div class="col-12" style="float: right;">
            <div class="col-7"></div>
            <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center col-1"
                style="float: right; max-width: 35px;" (click)="refreshGridData()" (keydown.enter)="refreshGridData()" matTooltip="Refresh Grid">
                <i class="fas fa-redo-alt"></i>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
                style="float: right;" *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                    <path style="fill:'#FFFFFF'"
                        d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
                </svg>
                <span class="reload_text text-white">Settings</span>
            </div>
            <div class="col-1 button-continer" style="float: right;">
                <button mat-stroked-button class="addButton" style="float: right; height:36px;"
                    *ngIf="displayReviewButton" (click)="reviewTrainingPopup('selected')">
                    <i class="fa-solid fa-clipboard-check"></i> Review</button>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)" style="float: right;"
                (keydown.enter)="openAuditTrail('overAll',0)" style="float: right;">
                <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Audit Trail</span>
            </div>
        </div>
        <div class="table-container">
            <table style="height: 60vh;">
                <thead style="z-index:9">
                    <th style="min-width: 60px; text-align: center;"
                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                        <div style="margin-top: 25px;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div>
                                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox"
                                    (change)="dataGridParentCheckBoxChecked($event)">
                            </div>
                        </div>
                    </th>
                    <th id="grid-header-container"
                        *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
                        [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'white-space': 'nowrap'}" class="sticky-dynamic-col1" >
                        <div>
                            <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                            <div class="row-search-container">
                                <input type="text" class="form-control" placeholder="Search"
                                    (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
                            </div>
                        </div>
                    </th>
                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
                    <td style="min-width: 60px; text-align: center;"
                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                        <div style="display: flex;">
                            <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div>
                                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                                    (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                            </div>
                        </div>
                    </td>
                    <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                        class="sticky-dynamic-row1" [ngStyle]="{'min-width': 200,'max-width': 200,'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}">
                        <span *ngIf="key.dataType=='CHECKBOX'">
                            <div class="gridCheckBoxes">
                                <img *ngIf="list[key.columnsListarray] || list[key.columnsListarray]=='Y'"
                                    src="../../../assets/img/cr_module/accessSymbol.svg" alt="Yes" width="20"
                                    height="20">
                            </div>
                        </span>
                        <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'" [ngStyle]="{
                color:
                  key.columnsListarray == 'REVIEW_STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') )
                    ? '#FF3A29'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Reviewed'))
                    ? '#FF8900'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('DPR'))
                    ? '#00E58F' 
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Pending'))
                    ? '#00E58F' 
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes(''))
                    ? ''                    
                    : '',
                background:
                  key.columnsListarray == 'REVIEW_STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') )
                    ? '##FF3A291A'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Reviewed') )
                    ? '#FF89001A'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('DPR') )
                    ? '#00E58F1A' 
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Pending') )
                    ? '#00E58F1A' 
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes(''))
                    ? ''                     
                    : '',
                border:
                  key.columnsListarray == 'REVIEW_STATUS' &&
                  (list[key.columnsListarray].includes('Rejected') )
                    ? '0.75px solid #FF3A29'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Reviewed') )
                    ? '0.75px solid #FF8900'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('DPR') )
                    ? '0.75px solid #00E58F'
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes('Pending') )
                    ? '#00E58F1A' 
                    : key.columnsListarray == 'REVIEW_STATUS' &&
                      (list[key.columnsListarray].includes(''))
                    ? ''  
                    : '',
                'font-family':
                  key.columnsListarray == 'REVIEW_STATUS' ? 'Poppins' : '',
                'border-radius': '6px',
                padding: '3px 9px'
              }">
                            <span *ngIf="list[key.columnsListarray]!='Y' && list[key.columnsListarray]!='N'">
                                {{list[key.columnsListarray]}}
                            </span>
                            <img *ngIf="list[key.columnsListarray]=='Y'"
                                src="../../../assets/img/cr_module/accessSymbol.svg" alt="Yes" width="20" height="20">
                            <img *ngIf="list[key.columnsListarray]=='N'"
                                src="../../../assets/img/cr_module/noAcessSymbol.svg" alt="No" width="20"
                                height="20"></span>
                        <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                    </td>
                    <td class="sticky-col first-col">
                        <div class="action-icons">
                            <i class="fa-solid fa-clipboard-check" (click)="reviewTrainingHover(list)" (keydown.enter)="reviewTrainingHover(list)"
                                matTooltip="Review"></i> &nbsp;
                            <i class="fa-solid fa-clipboard" title="Audit Trail" style="margin-left: 5px;"
                                *ngIf="message.isAuditTrailUser"
                                (click)="openAuditTrail('individual',list['USER_TRAINING_ID'])" (keydown.enter)="openAuditTrail('individual',list['USER_TRAINING_ID'])"></i>

                        </div>

                    </td>

                </tr>
            </table>
        </div>
        <div class="row border-top mt-1 width-cheat small paginationCell">
            <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
            </nav>
            <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
                <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
                    [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
                    [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
                </ngb-pagination>
                <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic" ngbDropdownToggle>
                        {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </nav>
            <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
            </div>
        </div>
    </div>
</div>
<!--Training Review Popup-->
<ng-template #trainingReviwPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelTrainingReviewPopupFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">Review Training(s)</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container" class="form-continer">
        <div class="row">
            <div class="col-md-4 ">
                <label for="Action Required"><b> Action Required </b></label>
            </div>
            <div class="col-md-2 ">
                <input type="checkbox" style="zoom: 1.2;margin-top: 3px;margin-left: -34px;"
                    [checked]="isActionRequired" (change)="isActionRequiredFun($event)">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12">
                <div><label for="email" ><b>Comments</b></label><span class="mandatory-symbol"
                        *ngIf="isActionRequired">*</span> :</div>
                <textarea class="input-filed-textarea" rows="2" cols="50" style="min-height: 50px;"
                    [(ngModel)]="trainingReviewComments"></textarea>
            </div>
        </div><br>
        <div class="row">
            <div class="col-md-6">
                <div><label for="email" ><b>Review Status</b></label><span
                        class="mandatory-symbol">*</span> :</div>
                <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedReviewStatusForTraining"
                    [settings]="singleSelectDropdownSetting" [data]="reviewStatusDropDown"
                   (onDeSelect)="onReviewDeSelect($event)">
                    <div *ngIf="isProcessing" class="loading-spinner">Loading...</div>
                </ng-multiselect-dropdown>
            </div>
        </div>
    </div>
    <div class="button-continer" mat-dialog-actions style="margin-left: 100px;">
        <button mat-stroked-button class="addButton" *ngIf="!$singleReview" (click)="trainingReviewFun()">
            Review
        </button>
        <button mat-stroked-button class="addButton" *ngIf="$singleReview" (click)="trainingSingleReview()">
            Review
        </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button mat-stroked-button class="cancelButton" (click)="cancelTrainingReviewPopupFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
    <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
        <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
        <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
            }} ?</label>
    </div>
    <div *ngIf="!isForExcel" class="row" style="margin:10px">
        <div class="center" class="col-md-6">
            <mat-checkbox (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"></mat-checkbox>Do you wish to
            pick fields manually?
        </div>
        <div class="col-md-6" *ngIf="manuallyPicked">
            <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
            <ng-multiselect-dropdown class="multiselect-container" style="position: absolute; width: 45%;"
                [(ngModel)]="selectedColumns" [settings]="multiSelectDropdownSetting" [data]="dropDownForPdfColumn">
            </ng-multiselect-dropdown>
        </div>
        <div  class="row"></div>
        <div class="row justify-content-md-center" Style="margin-top:40px;">
            <div class="col-sm-4">
              <label id="reportLogo-validation" for="email">Report Logo</label>
            </div>
            <div class="col-sm-8">
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
                (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
                <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
                  matInput placeholder="search">
                <mat-option [value]="null" class="unselectStyle"
                  (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
                  (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col-sm-4">
              <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
            </div>
            <div class="col-sm-8">
                <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
                  (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
                  <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
                    matInput placeholder="search">                  
                    <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                    (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col-sm-4">
              <label id="report-validation" for="email">Is Save Report?</label>
            </div>
            <div class="col-sm-8">       
              <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
              <ng-container *ngIf="isSaveReport; else noisSaveReport">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
              </ng-container>
              <ng-template #noisSaveReport>
                  <span style="color: red;">No</span>
              </ng-template>
          </mat-slide-toggle>  
          </div>
          </div>
          <div class="row justify-content-md-center" *ngIf="isSaveReport">
            <div class="col-sm-4">
              <label id="Logo-validation" for="email">Report Name</label>
            </div>
            <div class="col-sm-8">       
              <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
          </div>
          
        </div>





    </div>

    <div>
        <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
            <button *ngIf="isForExcel && this.auditTrailsFlag!=0" mat-stroked-button class="addButton"
                (click)="generateReport('Excel')">
                <i class="fa fa-file-excel-o"></i> Generate
            </button>
            <button *ngIf="isForExcel && this.auditTrailsFlag==0" mat-stroked-button class="addButton"
                (click)="generateReportPeridicReview('Excel')">
                <i class="fa fa-file-excel-o"></i> Generate
            </button>
            <button *ngIf="!isForExcel && this.auditTrailsFlag!=0" mat-stroked-button class="addButton"
                (click)="generateReport('Pdf')">
                <i class="fa fa-file-pdf-o"></i> Generate
            </button>
            <button *ngIf="!isForExcel && this.auditTrailsFlag==0" mat-stroked-button class="addButton"
                (click)="generateReportPeridicReview('Pdf')">
                <i class="fa fa-file-pdf-o"></i> Generate
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>
<!-- audit grid-->
<ng-template #auditTrailPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Audit Trail</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="table-container" style="margin-top: 18px;">
        <div class="row">
            <div class="col-8"></div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Excel')"(keydown.enter)="openReportPopup('Excel')">
                <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">Excel Report</span>
            </div>
            <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
                (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
                <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                <span class="reload_text text-white">PDF Report</span>
            </div>
        </div> &nbsp;&nbsp;
        <table class="dynamic-table-container">
            <th style="min-width: 60px; text-align: center;vertical-align: bottom;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                    <div>
                        <i  class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
                    </div>
                </div>
            </th>
            <th 
                *ngFor="let oneQmsUsersDataForTable1Data of columnListsAuditTrails.fieldColumnarray; let ix = index;"
                [ngStyle]="{
            'min-width': oneQmsUsersDataForTable1Data.width !=null ? oneQmsUsersDataForTable1Data.width :'200px'}"
                class="sticky-dynamic-col1 grid-header-container" >
                <div class="thheader">
                    <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                    <div class="row-search-container">
                        <input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(columnListsAuditTrails.columnsListarray[ix],$event)">
                    </div>
                </div>
            </th>
            <th  class="sticky-col first-col menu"></th>
            <tr *ngFor="let list of pagedItemsForAudtitrails  | searchFilter : searchValue; let idx = index;"
                [class.highlightRow]="list.childCheckBoxs == true">
                <td style="min-width: 60px; text-align: center;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                    <div style="display: flex;">
                        <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div>
                            <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                                (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                        </div>
                    </div>
                </td>
                <td  *ngFor="let key of columnListsAuditTrails.columnsListarray1; let i = index;"
                    class="sticky-dynamic-row1 grid-row-container"
                    [ngClass]="list.differColumn.includes(key.columnsListarray) ?'audit-bg-highlight':''" [ngStyle]="{
            'max-width': key.width[i] !=null ? key.width[i] :'200px',
            'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" >
                    <span *ngIf="key.dataType=='CHECKBOX'">
                        <div class="gridCheckBoxes">
                            <img *ngIf="list[key.columnsListarray]" alt=" " src="../../assets/img/accessSymbol.svg" width="20"
                                height="20">
                            <img *ngIf="list[key.columnsListarray]==false" alt=" " src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20">
                        </div>
                    </span>
                    <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'"
                        [ngStyle]="{'color':
          (key.columnsListarray=='STATUS' && (list[key.columnsListarray].includes('Rejected')||list[key.columnsListarray].includes('Deleted')||list[key.columnsListarray].includes('Obsoleted')))?'red':
          (key.columnsListarray=='STATUS' && (list[key.columnsListarray].includes('Open')||list[key.columnsListarray].includes('Draft')||list[key.columnsListarray].includes('Scheduled')||list[key.columnsListarray].includes('Initiated')))?'orange':
          (key.columnsListarray=='STATUS' && (list[key.columnsListarray].includes('Closed')||list[key.columnsListarray].includes('Completed')||list[key.columnsListarray].includes('Approved')))?'green':
           i==0?'#07426A':'black','zoom':key.columnsListarray=='STATUS'?'1.2':'1','font-family':key.columnsListarray=='STATUS'?'Bahnschrift':''}">{{ list[key.columnsListarray]
                        }}</span>
                    <span *ngIf="key.dataType=='DATE'">
                        <span
                            *ngIf="key.columnsListarray!='CREATED_ON' && key.columnsListarray!='UPDATED_ON' && key.columnsListarray!='LAST_ACTION_ON'">
                            {{ list[key.columnsListarray] }}
                        </span>
                        <span
                            *ngIf="key.columnsListarray=='CREATED_ON' || key.columnsListarray=='UPDATED_ON' || key.columnsListarray=='LAST_ACTION_ON'">
                            {{ list[key.columnsListarray] | date:'dd-MMM-yyyy HH:mm:ss' }}
                        </span>
                    </span>
                </td>
            </tr>
        </table>
        <div>
            <div class="row border-top mt-1 width-cheat small paginationCell">
                <nav class="col-4 col-md-2 mt-2" aria-labelledby=" ">
                </nav>
                <div class="col-2 col-md-6 d-flex justify-content-end align-items-center">
                </div>
                <nav class="col-6 col-md-4 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
                    {{ showingRowsText }}
                    1-{{ perPageForAudtitrails }} of {{ collectionSizeForAudtitrails | number }}
                    <ngb-pagination class="leftpadding"
                        (pageChange)="setPageForAudtitrails(pagerForAudtitrails.currentPage,$event)" [disabled]="false"
                        [collectionSize]="pagerForAudtitrails.totalItems" [(page)]="pagerForAudtitrails.currentPage"
                        [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                        [boundaryLinks]="true" size="sm">
                    </ngb-pagination>
                    <div ngbDropdown class="d-inline-block leftpadding">
                        <button class="btn btn-primary btn-sm mr-1 " style="background:#07426A !important"
                            id="dropdownBasic1" ngbDropdownToggle>
                            {{perPageForAudtitrails}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCallForAudtitrails(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCallForAudtitrails(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCallForAudtitrails(50)">50</button>
                        </div>
                        per page
                    </div>
                </nav>
            </div>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>